import React from 'react'
import BaseEducationTab from './BaseEducationTab'

export default function Electives() {
  return <BaseEducationTab tabType="electives" />
}
